// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error {\n  border: 1px solid #b10444;\n}\n.no-error {\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
